
var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "managededitingworkflow",
	init: init,
	triggers: triggers,
	listeners: listeners,

	_managee: null,
	_workflow: null,
	_active: null,

	handle_reset: handle_reset,
	handle_update: handle_update
});

const initialState = {
	initiateFinish: false,
	workflow: null
};
function init() {
	this.push(initialState);
}

function triggers() {
	return {
		"edit": handle_editing,
		"reset": handle_reset,
		"actors:add": handle_add_actor,
		"actors:remove": handle_remove_actor,
		"workflow:update": handle_update_workflow,
		"workflow:finish": handle_finish_workflow,
		"workflow:initiateFinish": handle_initiate_finish_workflow
	};
}

function listeners(){
	return {
		"activemanagedworkflow:updated": handle_active_updated
	};
}

function handle_active_updated(data){
	this._active = data;
}

function handle_update_workflow(data){
	var actors = data.actors;
	var active = this._active.actors;
	var definition = this._active.definition || {};
	if(!active)
		return console.error("No active workflow");

	this.emit("usermetrics:trigger:track", "finish editing pathway", {
		pathway: this._active._id
	});

	var activeActors = active.reduce(function(result, actor){
		var label = actor.actor;
		var who = actor.who;
		if(!result[label]) result[label] = [];
		result[label].push({who: who._id, type: actor.type});
		return result;
	}, {});

	const isValidActors = Object.keys(actors).every(actorLabel => {
		const optionalActors = definition?.optionalActors || [];
		if(optionalActors.includes(actorLabel)) return true;
		const actor = actors[actorLabel];
		if(actor?.patientGroups || actor?.people){
			return actor?.patientGroups?.filter(e => e).length || actor?.people?.filter(e => e).length;
		} else {
			return actor?.filter(e => e).length;
		}
	});

	if(!isValidActors){
		return this.emit("toast:trigger:show", {
			content: "workflow.missingActors",
			style: "error"
		});
	}

	var operations = Object.keys(actors).reduce(function(result, name){
		var actorList = actors[name] || [];
		var existingList = activeActors[name] || [];

		if(actorList.patientGroups || actorList.people){
			actorList = toActorArray(actorList.patientGroups ?? [], "ManageGroup").concat(toActorArray(actorList.people ?? []));
		} else {
			actorList = toActorArray(actorList);
		}

		var removed = mergeIds(name, findMissing(existingList, actorList));
		var added = mergeIds(name, findMissing(actorList, existingList));

		return xtend(result, {
			remove: result.remove.concat(removed),
			add: result.add.concat(added),
		});
	}, {
		remove: [],
		add: []
	});

	operations.remove.forEach(handle_remove_actor, this);
	operations.add.forEach(handle_add_actor, this);

	if(definition.edit)
		this.handle_update(data.edit);

	this.handle_reset();
}

function toActorArray(list, type){
	return list?.reduce((result, who) => {
		if(who) return result.concat({who: who, type});
		return result;
	}, []) ?? [];
}

function mergeIds(label, ids) {
	return ids.map(function(id){
		return {
			actor: label,
			who: id.who,
			type: id.type
		};
	});
}

function findMissing(newItems, sourceItems) {
	return newItems.filter(item => {
		return !sourceItems.some(src => src.who === item.who);
	});
}

function handle_editing(data) {
	var workflow = data.workflow;
	var managee = data.managee;
	var group = data.group;
	if(!workflow || !managee) return;
	this._managee = managee;
	this._workflow = workflow;
	this._group = group;

	this.push({ workflow });

	this.emit("managedmanagers:trigger:load", {
		who: managee
	});

	this.emit("managedcontacts:trigger:load", {
		who: managee,
		group: group
	});

	this.emit("usermetrics:trigger:track", "start editing pathway", {
		pathway: workflow
	});

	this.dispatch("editing");
}

function handle_add_actor(data) {
	var managee = this._managee;
	var workflow = this._workflow;
	var group = this._group;
	var actor = data.actor;
	var who = data.who;
	var type = data.type;

	if(!who || !managee || !actor || !workflow || (actor === "Patient")) return;

	this.emit("usermetrics:trigger:track", "added actor to pathway", {
		actor: actor,
		pathway: workflow
	});

	this.emit("save:trigger:start");
	this.api.manage.workflow
		.actors.add(managee, workflow, actor, who, group, type)
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function handle_remove_actor(data) {
	var managee = this._managee;
	var workflow = this._workflow;
	var group = this._group;
	var actor = data.actor;
	var who = data.who;
	var type = data.type;

	if (!who && !managee && !actor && !workflow || (actor === "Patient"))
		return console.error("Missing data");

	this.emit("usermetrics:trigger:track", "removed actor from pathway", {
		actor: actor,
		pathway: workflow
	});

	this.emit("save:trigger:start");
	this.api.manage.workflow
		.actors.remove(managee, workflow, actor, who, group, type)
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function handle_initiate_finish_workflow(bool){
	const action = !!bool ? "open" : "close";
	this.emit("usermetrics:trigger:track", `${action} stop pathway popup`, {
		pathway: this._active.workflow
	});
	this.extend({initiateFinish: bool});
}

function handle_finish_workflow(data) {
	var workflow = data.workflow;
	var managee = data.managee;
	var group = data.group;

	if(!workflow || !managee)
		return console.error("Missing data");
	this._managee = managee;
	this._workflow = workflow;

	this.emit("usermetrics:trigger:track", "confirm stop pathway", {
		pathway: this._workflow
	});
	
	this.emit("save:trigger:start");
	this.api.manage.workflow
		.finish(managee, workflow, group)
		.then(finish_save.bind(this))
		.catch(handle_error.bind(this));
	this.handle_reset();
}

function handle_error(e) {
	this.emit("save:trigger:finish");
	console.error(e);
	this.emit("toast:trigger:show", {
		content: "workflow.error",
		style: "error"
	});
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function finish_save() {
	this.emit("save:trigger:finish");
	this.emit("toast:trigger:show", {
		content: "workflow.workflowsaved"
	});
}

function handle_reset() {
	if(!this.data) return;
	this.push(initialState);
	this.emit("managedmanagers:trigger:reset");
	this.dispatch("finished");
}

function handle_update(data){
	if(!data) return;
	var active = this._active || {};
	var ongoing = active._id;
	var managee = this._managee;
	var group = this._group;
	this.emit("save:trigger:start");
	this.api.manage.workflow.update(managee, ongoing, data, group)
		.then(finish_save.bind(this))
		.catch(handle_error.bind(this));
}
